export const getUserAccountId = (): string | null => {
  const accountId = localStorage.getItem("ansible-reference-id");

  if (!accountId) return null;

  return String(accountId);
};
